//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectionsMixin from '~/mixins/SelectionsMixin'
import Header from '~sdp-components/Header/Header'
import Navigation from '~/components/Navigation'
import Footer from '~sdp-components/Footer/Footer'
import Columns from '~sdp-components/PageElements/Columns'
import Column from '~sdp-components/PageElements/Column'
import QlikSelectedFilterPills from '~sdp-components/Qlik/QlikSelectedFilterPills'
import QlikCollapsableFilterContainer from '~sdp-components/Qlik/QlikCollapsableFilterContainer'
import QlikFilter from '~sdp-components/Qlik/QlikFilter'
import Square from '~sdp-components/PageElements/Square'
import Heading from '~sdp-components/PageElements/Heading'

export default {
  components: {
    Header,
    Navigation,
    Footer,
    Columns,
    Column,
    QlikSelectedFilterPills,
    QlikFilter,
    QlikCollapsableFilterContainer,
    Square,
    Heading,
  },
  mixins: [SelectionsMixin],
  data() {
    return {
      tourSteps: [
        {
          target: '#main-title',
          content:
            'Welcome to the College & Career Data Website. Here you can find data about high school students and graduates for both district and public charter schools in Philadelphia.',
          params: { enableScrolling: true },
          offset: -400,
        },
        {
          target: '#nav-grad',
          content:
            'This website is divided into four sections. You can navigate to any of these sections at any time.',
          params: { enableScrolling: false },
        },
        {
          target: '#main-content-side',
          content: 'Here you can view charts, maps, and tables.',
          params: { enableScrolling: true },
          offset: -400,
        },
        {
          target: '#main-filter-panel',
          content:
            'On this panel you can find a number of filters to narrow down the displayed schools and metrics.',
          params: { enableScrolling: true },
          offset: -400,
        },
        {
          target: '#main-filters',
          content:
            'Use the filters to narrow down school or student characteristics.',
          params: { enableScrolling: false },
        },
        {
          target: '#main-school-filter',
          content: 'Use the school filter to choose one or more schools.',
          params: { enableScrolling: false },
        },
        {
          target: '#main-tour-button',
          content: 'Press here to take this tour again.',
          params: { enableScrolling: true },
          offset: -400,
        },
      ],

      tourCallbacks: {
        onSkip: () => this.$store.dispatch('tour/initialize_main'),
        onFinish: () => this.$store.dispatch('tour/initialize_main'),
      },
    }
  },
  computed: {
    filterFieldValues() {
      return [
        // { field: 'SchoolYear_StudentMetrics_3Recent', label: 'School Year' },
        { field: 'Sector' },
        { field: 'Current Network', label: 'Network' },
        { field: 'Current AdmissionType', label: 'Admission Type' },
        // { field: 'Current ZipCode', label: 'ZIP Code' },
        { field: 'Ethnicity', label: 'Race/Ethnicity' },
        { field: 'Gender' },
        {
          field: 'EconDisadvantagedStatus',
          label: 'Economic Disadvantage',
        },
        { field: 'SPED', label: 'Special Education' },
        { field: 'ELStatus', label: 'EL Status' },
      ]
    },
  },
  mounted() {
    if (!this.$store.state.tour.main_initialized) this.launchTour()
  },
  /**
   * Remove field values that we don't want to carry to other pages
   */
  async destroyed() {
    const fieldsToClear = []
    const engine = await this.$qlik.engine
    let field
    fieldsToClear.forEach(async (fieldName) => {
      field = await engine.getField(fieldName)
      await field.clear()
    })
  },
  methods: {
    launchTour() {
      this.$tours.mainTour.start()
    },
  },
}
